module.exports = __webpack_public_path__ + "img/right pag.b1ac05e8.svg";